/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IFlexoSONPacketMap {
        version: number;
        switches: Models.ISonNode[];
        links: Models.ISonLink[];
        center?: {
            x: number;
            y: number;
        };
        sonNetwork?: Models.INetwork;
        showSonCollapsed: boolean;
    }

    export class FlexoSONPacketMap implements IFlexoSONPacketMap {
        public version: number;
        public switches: Models.ISonNode[];
        public links: Models.ISonLink[];
        public  center?: {
            x: number;
            y: number;
        };
        public sonNetwork?: Models.INetwork;
        public showSonCollapsed: boolean;


        public static Empty(): FlexoSONPacketMap {
            return new FlexoSONPacketMap();
        }

        /**
         * FlexoSONPacketMap's empty contructor for automatic conversion from
         * REST data.
         *
         */
        constructor() {
            // do nothing
        }

        // Get every node connected to the given node
        public getNodesConnectedToNode( node: Models.ISonNode ): Models.ISonNode[] {
            const nodeIds: number[] = this.links.filter( ( link: Models.ISonLink ) => {
                return node.id === link.source.id || node.id === link.target.id;
            }).map( (link: Models.ISonLink) => {
                return link.source.id === node.id ?  link.target.id : link.source.id;
            });
            return this.switches.filter( (sonNode: Models.ISonNode ) => {
                return nodeIds.indexOf( sonNode.id ) > -1;
            });
        }

        // Get every port connected to the given node
        public getPortsConnectedToNode( node: Models.ISonNode ): Models.ISonNode[] {
            return this.getNodesConnectedToNode( node ).filter( ( sonNode: Models.ISonNode ) => {
                return sonNode.group === 'vport';
            });
        }

    }
}